import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { ShaDowBox } from "../../../../../components/boxes";
import { TenancyData } from "../../../../../components/parts";
import { NO_DATA_TEXT } from "../../../../../constants";
import { nFormatter, currencyFormatter, getData } from "../../../../../services";

const defaultResults = (unitSystem) => [
  {
    title: "Total Units",
    value: 0,
  },
  {
    title: "Total Tenants",
    value: 0,
  },
  {
    title: "Avg. Tenancy Rate",
    value: 0,
    unit: `/${unitSystem}`,
  },
  {
    title: "Economic Vacancy",
    value: 0,
    unit: `${unitSystem} (0)`,
  },
  {
    title: "Physical Vacancy",
    value: 0,
    unit: `${unitSystem} (0)`,
  },
  {
    title: "Gross Rental Revenues",
    value: 0,
    unit: "/month",
  },
];

export const TenancyDataInfo = ({ building, complex }) => {
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;
  const [results, setResults] = useState(defaultResults(user.unit_system));
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    let url = `/praas/v1/buildings/tenants-info/`;

    if (building?.id) {
      url = `/praas/v2/buildings/${building.id}/tenants/tenancy-data/`;
    } else if (complex?.id) {
      url = `/praas/v2/complexes/${complex.id}/tenants/tenancy-data/`;
    }

    getData(url, (data) => {
      setResults([
        {
          title: "Total Units",
          value: nFormatter(data.total_units),
        },
        {
          title: "Total Tenants",
          value: nFormatter(data.total_tenants),
        },
        {
          title: "Avg. Tenancy Rate",
          value: currencyFormatter(data.tenancy_rate, currencySymbol),
          unit: `/${user.unit_system}`,
        },
        {
          title: "Economic Vacancy",
          value: getVacancyValue(data.economic_vacancy),
          unit: getVacancyUnit(data.economic_vacancy),
        },
        {
          title: "Physical Vacancy",
          value: getVacancyValue(data.physical_vacancy),
          unit: getVacancyUnit(data.physical_vacancy),
        },
        {
          title: "Gross Rental Revenues",
          value: currencyFormatter(data.gross_rental_revenues, currencySymbol),
          unit: "/month",
        },
      ]);
    });

    return () => setResults(defaultResults(user.unit_system));
  }, [building?.id, complex?.id, cluster, segments, selectedCountries]);

  const getVacancyValue = (vacancy) => {
    if (vacancy.square) {
      return nFormatter(vacancy.square);
    } else if (vacancy.rate !== null) {
      return vacancy.rate;
    }
    return NO_DATA_TEXT;
  };

  const getVacancyUnit = (vacancy) => {
    if (vacancy.square) {
      return `${user.unit_system} (${vacancy.rate}%)`;
    } else if (vacancy.rate !== null) {
      return "%";
    }
    return;
  };

  return (
    <ShaDowBox>
      <TenancyData results={results} />
    </ShaDowBox>
  );
};
